export const stjeanTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_sectors: 'Secteurs',
  breadcrumb_current: 'Saint-Jean-Chrysostome',
  hero_h1: "Couvreur à Saint-Jean-Chrysostome : toiture neuve et réfection",
  hero_subtitle: "Spécialistes des toitures à Saint-Jean-Chrysostome. Nouveaux développements et anciennes propriétés. Soumission gratuite en 2h.",
  hero_cta: "Demander ma soumission Saint-Jean-Chrysostome",
  hero_stat_1: 'Plusieurs dizaines de mises en relation',
  hero_stat_2: 'Certifié',
  hero_stat_3: 'Secteur en croissance',

  // Connaitre le quartier
  quartier_h2: "Saint-Jean-Chrysostome : un secteur en pleine croissance",
  quartier_p1: "Saint-Jean-Chrysostome, ça change vite. Entre l'ancien noyau villageois autour de la rue Principale et de l'église, et les nouveaux développements près des routes du Président-Kennedy et de l'Église, le secteur attire de plus en plus de jeunes familles à la recherche de maisons neuves abordables. C'est devenu un des quartiers les plus dynamiques de Lévis.",
  quartier_p2: "Deux réalités coexistent ici : des toitures neuves arrivant à mi-vie (15-20 ans après la construction 2005-2010), et des anciennes maisons de ferme ou de village demandant une restauration plus complexe. Notre réseau de couvreurs partenaires connaît les deux univers et adapte son approche selon votre maison, que ce soit sur la rue Principale ou le chemin Olivier.",

  // Profil toitures
  profil_h2: "Les 3 réalités à Saint-Jean-Chrysostome",
  profil_1_title: 'MAISONS RÉCENTES (2005-2015)',
  profil_1_desc: "Cottages familiaux avec bardeau architectural arrivant à mi-vie. Première réfection dans les 5 prochaines années pour beaucoup. Choix : bardeau neuf ou conversion vers la tôle pour durabilité.",
  profil_2_title: 'ANCIENNES MAISONS DU VILLAGE',
  profil_2_desc: "Noyau historique autour de l'église et de la rue Principale. Maisons centenaires aux structures parfois fragilisées. Inspection pontage rigoureuse obligatoire avant tout travail.",
  profil_3_title: 'FERMETTES PÉRIPHÉRIQUES',
  profil_3_desc: "Anciennes maisons de ferme le long du chemin Olivier et des routes rurales. Grandes surfaces avec dépendances, souvent avec pontage vieillissant et ventilation à moderniser.",

  // Services
  services_h2: "Tous nos services à Saint-Jean-Chrysostome",
  service_1: 'Réfection bardeau architectural',
  service_2: 'Conversion bardeau vers tôle',
  service_3: 'Restauration toitures anciennes',
  service_4: 'Réparation et infiltration urgence',
  service_5: 'Inspection préachat (très demandée)',
  service_6: 'Déneigement et déglaçage',

  // Prix
  prix_h2: "Prix moyens à Saint-Jean-Chrysostome 2026",
  prix_table_type: 'Type de maison',
  prix_table_price: 'Fourchette 2026',
  prix_row_1_type: 'Bungalow récent 1 300-1 600 pi² (bardeau)',
  prix_row_1_price: '8 000 $ – 12 500 $',
  prix_row_2_type: 'Cottage 1 800-2 200 pi² (bardeau)',
  prix_row_2_price: '11 000 $ – 16 500 $',
  prix_row_3_type: 'Maison ancienne avec pontage',
  prix_row_3_price: '12 000 $ – 22 000 $',
  prix_row_4_type: 'Conversion vers tôle joint debout',
  prix_row_4_price: '20 000 $ – 38 000 $',
  prix_note: "Inspection préachat avant transaction disponible. Soumission précise après inspection sur place.",

  // Projets récents
  projets_h2: "Projets récents à Saint-Jean-Chrysostome",
  projet_1_title: 'Président-Kennedy',
  projet_1_desc: "Réfection bardeau cottage 2008, août 2025",
  projet_2_title: 'Rue Principale',
  projet_2_desc: "Restauration toiture village avec pontage, juin 2025",
  projet_3_title: 'Chemin Olivier',
  projet_3_desc: "Conversion bardeau vers tôle fermette, juillet 2025",

  // Témoignage
  temoignage_quote: "On a acheté notre maison sur la route du Président-Kennedy en 2019, construite en 2007. Après un hiver particulièrement rigoureux, on a remarqué des glaçons en barde près des gouttières et des taches au plafond de l'entrée. Un couvreur partenaire de Couvreur-Lévis.com est venu inspecter le lendemain de notre appel. Le rapport a montré que le bardeau architectural avait 5-6 ans de vie seulement, mais que la ventilation entretoit était insuffisante depuis la construction. On a fait toute la réfection en bardeau IKO Cambridge avec ajout de ventilation. L'équipe a été super respectueuse — on a deux jeunes enfants et ils ont tout protégé, pas de clous dans la cour. Très satisfaits.",
  temoignage_author: 'Caroline et Sébastien R.',
  temoignage_rue: 'Président-Kennedy',
  temoignage_city: 'Saint-Jean-Chrysostome',
  temoignage_detail: "Réfection bardeau, août 2025",

  // Zones proches
  zones_h2: 'On dessert aussi',
  zone_saint_nicolas: 'Saint-Nicolas',
  zone_pintendre: 'Pintendre',
  zone_charny: 'Charny',
  zone_saint_romuald: 'Saint-Romuald',

  // CTA Final
  cta_h2: "Votre toiture à Saint-Jean-Chrysostome, neuve ou ancienne",
  cta_subtitle: 'Soumission gratuite en 2h, équipe locale, garantie 10 ans.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: '418-476-9950',
};

export default stjeanTranslations;